import { difference } from "lodash";

export const findDiff = (oldList: string[], newList: string[]) => {
  return {
    toAdd: difference(newList, oldList),
    toDelete: difference(oldList, newList),
  };
};
